import Box from '@mui/material/Box';
import SimpleCounterDashboard from '@/components/common/dashboard/simple-counter.dashboard';
import { Avatar } from '@/utils/types';
import BorderBlockWithLabel from '@/components/common/border-block-with-label/border-block-with-label';
import ContractualMaintenanceDashboard from '@/components/dashboards/contractual-maintenance-dashboard';
import InterventionsRequestedDashboard from '@/components/dashboards/interventions-requested-dashboard';

interface Props {
    params: { client_id?: string; site_id?: string; place_id?: string };
    avatar: Avatar;
    clientOrSite: 'client' | 'site' | 'place';
}

const DashboardsInfoBox = ({ params, clientOrSite, avatar }: Props) => (
    <Box
        sx={{
            display: 'grid',
            gap: 2,
            justifyContent: 'center',
            justifyItems: 'center',
        }}
    >
        {avatar && <SimpleCounterDashboard avatar={avatar} />}

        <Box
            sx={{
                display: 'grid',
                gap: 2,
                gridTemplateColumns: 'repeat(2, auto)',
            }}
        >
            <BorderBlockWithLabel>
                <ContractualMaintenanceDashboard params={params} clientOrSite={clientOrSite} avatar={avatar}/>
            </BorderBlockWithLabel>

            <BorderBlockWithLabel>
                <InterventionsRequestedDashboard params={params} clientOrSite={clientOrSite} avatar={avatar}/>
            </BorderBlockWithLabel>
        </Box>
    </Box>
);

export default DashboardsInfoBox;
